import { createElementId } from '../createElementId/createElementId';
import { IAppConfig } from '../interfaces/IAppConfig';

export interface IDisplayNameFactory {
    (name: string): string;
}

export function createDisplayNameFactory (appConfig: IAppConfig): IDisplayNameFactory {
    return (name: string): string => {
        try {
            return createElementId(appConfig.COMPONENT_PREFIX, name);
        } catch {
            // Need to throw a different error to make it more clear what happened
            throw new Error(`Display name created using "${name}" which is non-standard. Name must be UpperCamelCase.`);
        }
    };
}
